import { E_LABELS_ROUTE_NAME } from 'utils/consts/routes/elabels'
import { eLabelsFiltersName } from './keys'

const eLabelsDefaultFilters = [
  eLabelsFiltersName.updateUserUsernameFilter,
  eLabelsFiltersName.countryFilter,
  eLabelsFiltersName.creationDateFilter,
  eLabelsFiltersName.lastUpdateFilter,
  eLabelsFiltersName.brandFilter,
  eLabelsFiltersName.nationalGITypeFilter,
  eLabelsFiltersName.geoIndicationFilter,
  eLabelsFiltersName.specialClassificationFilter,
  eLabelsFiltersName.wineTypeFilter,
  eLabelsFiltersName.wineTypeEUFilter,
  eLabelsFiltersName.wineColourFilter,
  eLabelsFiltersName.sweetnessTypeFilter,
  eLabelsFiltersName.vintageFilter,
  eLabelsFiltersName.bottleSizeFilter,
  eLabelsFiltersName.packageTypeFilter,
  eLabelsFiltersName.grapesFilter,
  eLabelsFiltersName.additionalInfoFilter,
  eLabelsFiltersName.alcoholLevelFilter,
  eLabelsFiltersName.ingredientsFilledFilter,
  eLabelsFiltersName.nutritionDeclarationFilledFilter,
]

// указываются списки фильтров и их порядок в зависимости от роута
export const includedELabelsFiltersOnRoute = {
  [E_LABELS_ROUTE_NAME]: {
    default: eLabelsDefaultFilters,
  },
}
